SupportBasePresentation = require('./base')
SupportGoodsVoucherStatusAndNotesPresentation = require('./goods_voucher_messages')

class SupportGoodsVoucherPresenterPresentation extends SupportBasePresentation
	getLookupObject: () ->
		SupportGoodsVoucherStatusAndNotesPresentation

module.exports = SupportGoodsVoucherPresenterPresentation
